const useGetTextColor = () => {
  function hexToRgb(hex: string) {
    // Rimuove il simbolo '#' se presente
    hex = hex.replace(/^#/, '');

    // Converte valori corti (3 caratteri) in valori lunghi (6 caratteri)
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map(char => char + char)
        .join('');
    }
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
  }

  function rgbaStringToRgb(rgba: string) {
    // Supporta sia rgba che rgb
    const match = rgba
      .replace(/\s+/g, '')
      .match(/^rgba?\((\d{1,3}),(\d{1,3}),(\d{1,3})(?:,([01]?\.?\d*))?\)$/i);
    if (!match) return undefined;
    const r = parseInt(match[1], 10);
    const g = parseInt(match[2], 10);
    const b = parseInt(match[3], 10);
    return { r, g, b };
  }

  function getLuminance(r: number, g: number, b: number) {
    const a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }

  function pickTextColorBasedOnBgColorSimple(r: number, g: number, b: number) {
    const luminance = getLuminance(r, g, b);
    return luminance > 0.179 ? 'black' : 'white';
  }

  return {
    getTextColor: (color?: string) => {
      if (!color) return undefined;
      let rgb;
      if (color.startsWith('#')) {
        rgb = hexToRgb(color);
      } else if (color.startsWith('rgb')) {
        rgb = rgbaStringToRgb(color);
      }
      if (!rgb) return undefined;
      return pickTextColorBasedOnBgColorSimple(rgb.r, rgb.g, rgb.b);
    },
  };
};

export default useGetTextColor;
